import React from "react";
import { Button, Modal, Table } from '@themesberg/react-bootstrap';
import RewardTable from './partials/reward-table'

const formatVnd = (value) => {
  if (value == null || Number.isNaN(Number(value))) return "—";
  return new Intl.NumberFormat('vi-VN').format(Number(value));
};

const SummaryRow = ({ label, value, emphasize }) => (
  <tr>
    <td className="text-muted" style={{ width: '62%', borderTop: 'none' }}>{label}</td>
    <td className={`text-end ${emphasize ? 'fw-bold' : ''}`} style={{ borderTop: 'none' }}>{value}</td>
  </tr>
);

export default (props) => {
  const reward = props.reward || {};
  const ticket = reward.ticket;
  const count = ticket && Number(ticket.rewardCount) > 0 ? Number(ticket.rewardCount) : 0;
  const hasBreakdown = Array.isArray(ticket?.rewards) && ticket.rewards.length > 0;

  const grossPerPrize = count > 0 ? reward.grossValue / count : null;

  const titleTicket = reward.ticketId
    ? ` · Vé: ${reward.ticketId}`
    : ticket?.cartId
      ? ` · Mã đơn: ${ticket.cartId}`
      : '';

  return (
    <Modal
      {...props}
      size="xl"
      aria-labelledby="big-reward-detail-title"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title style={{ fontWeight: 600, fontSize: '1rem' }} id="big-reward-detail-title">
          Chi tiết giải thưởng{titleTicket}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {!ticket && (
          <p className="text-muted mb-0">Không có dữ liệu vé cho mục này.</p>
        )}
        {ticket && (
          <>
            {hasBreakdown && (
              <>
                <h6 className="text-uppercase text-muted small mb-2">Theo từng loại giải</h6>
                <RewardTable
                  rewards={ticket.rewards}
                  rewardNumber={ticket.rewardNumbers}
                />
                <hr className="my-3" />
              </>
            )}
            <h6 className="text-uppercase text-muted small mb-2">Tóm tắt tiền thưởng</h6>
            <Table borderless size="sm" className="mb-0">
              <tbody>
                <SummaryRow
                  label="Giá trị mỗi giải (trước thuế/phí)"
                  value={formatVnd(grossPerPrize)}
                />
                <SummaryRow
                  label=" * Số giải trúng"
                  value={count > 0 ? formatVnd(count) : "—"}
                />
                <SummaryRow
                  label="= Tổng tiền thưởng (trước thuế/phí)"
                  value={formatVnd(reward.grossValue)}
                />
                <SummaryRow
                  label=" - Thuế (tổng)"
                  value={formatVnd(reward.tax)}
                />
                <SummaryRow
                  label=" - Phí (tổng)"
                  value={formatVnd(reward.fee)}
                />
                <SummaryRow
                  label="= Tổng tiền thưởng thực nhận"
                  value={formatVnd(reward.netValue)}
                  emphasize
                />
              </tbody>
            </Table>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={props.onHide}>Đóng</Button>
      </Modal.Footer>
    </Modal>
  );
}
